export default theme => {
  return {
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/theme/components/generic/Loading.js